import '../css/app.scss';
import Gallery from './components/gallery';
import Slider from './components/slider';
import Accordions from './components/accordions';
import SpSuperMarquee from 'sp-supermarquee';
import Loader from './components/loader';
import Dialog from './components/dialog';
import Scroll from './components/scroll';
import HeroSlider from './components/heroSlider';
import Widget from './components/widget';


/** Global Components */

/** Bootstrap */


$(() => {

    // SuperMarquee
    const marqueeElement = document.querySelector('.supermarquee');

    var isVisible = $(marqueeElement).data('visible');
    if (isVisible != true) {
        $(marqueeElement).hide();
    }
    if (marqueeElement) {
        const mySuperMarquee = new SpSuperMarquee(marqueeElement);
        mySuperMarquee.setScrollSpeed("medium");
    }

    // Loader
    const $loader = $('[data-loader="el"]');
    if ($loader.length) {
    const loader = new Loader($loader, () => {
        const $heroSlider = $('[data-heroslider="el"]');
        new HeroSlider($heroSlider);
    });
    }

    // Swiper Slider
    const $slider = $('[data-slider="el"]');
    if ($slider.length) {
        $slider.each(function (i, element) {
            new Slider($(element));
        });
    }

    // Gallery
    const $gallery = $('[data-gallery="el"]');
    if ($gallery.length) {
        new Gallery($gallery);
    }

    // Accordions
    const $accordions = $('[data-accordions="el"]');
    if ($accordions.length) {
        $accordions.each(function (i, element) {
            new Accordions($(element));
        });
    }


    // Scroll Animations
    const $scroll = $('[data-scroll="text"]');
    const $appear = $('[data-scroll="appear"]');
    new Scroll($scroll, $appear);


    // Dialog
    const $dialog = $('[data-gallery="trigger"]');
    if ($dialog.length) {
        $dialog.each(function (i, element) {
            new Dialog($(element));
        });
    }




    // Scroll to Top
    const $scrollUp = $('[data-scrollUp="el"]');
    $scrollUp.on('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    const $scrollDown = $('[data-scrollDown="el"]');
    const $scrollTo = $('[data-scrollTo="el"]');


    const $escapeWidget = $('.widget-root');
    if($escapeWidget) {
        $escapeWidget.remove();
    }
    const $widget = $('[data-widget="el"]');
    new Widget($widget);


    $scrollDown.on('click', function () {
        const scrollTargetOffset = $scrollTo.offset().top;
        window.scrollTo({
            top: scrollTargetOffset,
            behavior: 'smooth'
        });
    });



});









